import { ITriggerRule, TriggerContext } from '@lifetools/shared-database';
import { services } from '@lifetools/shared-services';

const updateUpdatedFields: ITriggerRule = {
  stage: 'before',
  operation: 'update',
  func: async ({ changes }: TriggerContext) => {
    if (changes.values) {
      changes.set('updatedAt', services.database.fieldValues.serverTimestamp());
      changes.set('updatedBy', services.auth.userId());
    }
  },
};

export default updateUpdatedFields;
